import { render } from "./ArchiveAlbumSlider.vue?vue&type=template&id=6d530e76"
import script from "./ArchiveAlbumSlider.vue?vue&type=script&lang=js"
export * from "./ArchiveAlbumSlider.vue?vue&type=script&lang=js"

import "./ArchiveAlbumSlider.vue?vue&type=style&index=0&id=6d530e76&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__